/**
 * Service API pour le Chatbot S2i
 * Gère toutes les interactions avec le Backend Spring Boot
 */

// Configuration de l'API (Pointe vers Spring Boot sur le port 8080)
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://www.s2i.com.tn';

class ChatbotAPIError extends Error {
  constructor(message, status, data) {
    super(message);
    this.name = 'ChatbotAPIError';
    this.status = status;
    this.data = data;
  }
}

class ChatbotService {
  constructor(baseURL = API_BASE_URL) {
    this.baseURL = baseURL;
    this.defaultHeaders = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    };
  }

  async makeRequest(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;
    const config = {
      method: 'GET',
      headers: { ...this.defaultHeaders },
      ...options,
    };

    if (options.body && typeof options.body === 'object') {
      config.body = JSON.stringify(options.body);
    }

    try {
      const response = await fetch(url, config);
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new ChatbotAPIError(
          errorData.detail || `HTTP ${response.status}: ${response.statusText}`,
          response.status,
          errorData
        );
      }
      return await response.json();
    } catch (error) {
      if (error instanceof ChatbotAPIError) throw error;
      throw new ChatbotAPIError(`Erreur de connexion: ${error.message}`, 0, { originalError: error });
    }
  }

  /**
   * ✅ MODIFIÉ : Envoie un message via le Backend Spring Boot
   */
  async sendMessage(message, userId = null, context = null) {
    if (!message || message.trim().length === 0) throw new Error('Le message est vide');

    const requestBody = {
      message: message.trim(),
      ...(userId && { user_id: userId }),
      ...(context && { context }),
    };

    // Utilisation de l'URL complète configurée dans votre ChatController Java
    return await this.makeRequest('/api/public/chat', {
      method: 'POST',
      body: requestBody,
    });
  }

  /**
   * ✅ MODIFIÉ : Vérifie la santé de l'API via Spring Boot
   */
  async checkHealth() {
    return await this.makeRequest('/api/public/chat/health');
  }

  async isApiAvailable() {
    try {
      await this.checkHealth();
      return true;
    } catch (error) {
      console.warn('API non disponible:', error.message);
      return false;
    }
  }

  // Autres méthodes (historique, stats...) restent identiques mais 
  // doivent aussi pointer vers /api/public/chat/... si implémentées côté Java.
  async getChatHistory(limit = 50, userId = null) {
    const params = new URLSearchParams();
    if (limit) params.append('limit', limit.toString());
    if (userId) params.append('user_id', userId);
    return await this.makeRequest(`/api/public/chat/history?${params.toString()}`);
  }
}

const chatbotService = new ChatbotService();
export default chatbotService;
export { ChatbotService, ChatbotAPIError };